<div class="detail-page-action-bar">
    <button class="btn btn-cerrix" (click)="export()" [disabled]="!(selectedExportType > 0)">
        <i class="fas fa-save"></i>
        <span class="d-none d-lg-inline">{{ 'devExport.downloadExport' | t }}</span>
    </button>
</div>

<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'devExport.exportConfiguration' | t }}</div>
    <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
        @if (exportTypes) {
            <div>
                <div class="form-group">
                    <label for="typeSelect">{{ 'devExport.exportType' | t }}</label>
                    <ng-select
                        id="typeSelect"
                        name="typeSelect"
                        [items]="exportTypes"
                        [(ngModel)]="selectedExportType"
                        bindLabel="Value"
                        bindValue="Key"
                        [closeOnSelect]="true"
                        [multiple]="false"
                        [clearable]="false"
                    >
                    </ng-select>
                </div>
            </div>
        } @else {
            <div class="fancy-loader submodule"></div>
        }
    </div>
</div>
